// extracted by mini-css-extract-plugin
export default {"FAQWrapper":"FAQ_FAQWrapper__lYehP"};